import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize Google Analytics
    if (window.gtag) {
      window.gtag('config', 'G-XXXXXXXXXX', {
        page_path: location.pathname + location.search,
      });
    }

    // Track page view
    trackPageView(location.pathname);
  }, [location]);

  return null;
};

// Analytics utility functions
export const initializeAnalytics = (measurementId) => {
  // Google Analytics 4
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script1);

  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${measurementId}', {
      page_path: window.location.pathname,
      send_page_view: true
    });
  `;
  document.head.appendChild(script2);
};

export const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: document.title,
      page_location: window.location.href
    });
  }
  console.log('Page View:', path);
};

export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
  console.log('Event:', eventName, eventParams);
};

// Specific event tracking functions
export const trackButtonClick = (buttonName, location) => {
  trackEvent('button_click', {
    button_name: buttonName,
    location: location
  });
};

export const trackFormSubmit = (formName, success = true) => {
  trackEvent('form_submit', {
    form_name: formName,
    success: success
  });
};

export const trackLinkClick = (linkText, destination) => {
  trackEvent('link_click', {
    link_text: linkText,
    destination: destination
  });
};

export const trackSocialClick = (platform) => {
  trackEvent('social_click', {
    platform: platform
  });
};

export const trackDownload = (fileName) => {
  trackEvent('file_download', {
    file_name: fileName
  });
};

export const trackSearch = (searchTerm) => {
  trackEvent('search', {
    search_term: searchTerm
  });
};

export const trackOutboundLink = (url) => {
  trackEvent('outbound_link', {
    url: url
  });
};

export const trackCTAClick = (ctaName, ctaLocation) => {
  trackEvent('cta_click', {
    cta_name: ctaName,
    cta_location: ctaLocation
  });
};

export const trackFilterChange = (filterType, filterValue) => {
  trackEvent('filter_change', {
    filter_type: filterType,
    filter_value: filterValue
  });
};

export const trackVideoPlay = (videoName) => {
  trackEvent('video_play', {
    video_name: videoName
  });
};

export default Analytics;
